module.exports = __webpack_public_path__ + "static/media/recommendedb1.16d93107.png";